<jw-modal id='contactAccountModal'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <h1 class='header'>Select Account</h1>

  <app-grid
    entity='account'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
    [checkboxSelector]='true'
    (checkboxSelected)='this.onCheckedSelected($event)'
    [amount]='10'
  ></app-grid>


  <button class='btn btn-success' (click)='this.save()'>Save</button>&nbsp;
  <button class='btn btn-danger' (click)='this.cancel()'>Cancel</button>
</jw-modal>